export default __webpack_public_path__ + "static/gardener-2bcc72f439d057edec3067cf99010335.png";